export default __webpack_public_path__ + "static/media/9C4A5236.d8643852.jpg";